import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { Lock, Mail, ArrowLeft, CheckCircle, AlertCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!email) {
      setError('Introduce tu email');
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setMessage(res.data?.message || 'Email enviado.');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Ocurrió un error. Inténtalo de nuevo.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-red-900 px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-red-600/20 backdrop-blur-sm border border-red-500/30 mb-4">
            <Lock size={32} className="text-red-400" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">Restablecer contraseña</h1>
          <p className="text-slate-400 text-sm">DRYWALL DESING LLC</p>
        </div>

        <Card className="border-0 shadow-2xl bg-white/95 backdrop-blur">
          <CardHeader className="pb-4">
            <CardTitle className="text-xl text-slate-900">¿Olvidaste tu contraseña?</CardTitle>
            <p className="text-sm text-slate-500">
              Introduce el email del administrador y te enviaremos un enlace para crear una nueva
              contraseña.
            </p>
          </CardHeader>
          <CardContent>
            {message ? (
              <div
                data-testid="forgot-success"
                className="flex items-start gap-2 p-4 rounded-lg bg-green-50 border border-green-200 text-green-800 text-sm"
              >
                <CheckCircle size={18} className="flex-shrink-0 mt-0.5" />
                <span>{message}</span>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-form">
                {error && (
                  <div
                    data-testid="forgot-error"
                    className="flex items-start gap-2 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm"
                  >
                    <AlertCircle size={18} className="flex-shrink-0 mt-0.5" />
                    <span>{error}</span>
                  </div>
                )}
                <div className="space-y-2">
                  <Label htmlFor="forgot-email">Email del administrador</Label>
                  <div className="relative">
                    <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                    <Input
                      id="forgot-email"
                      data-testid="forgot-email-input"
                      type="email"
                      autoComplete="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="info@drywall-design.com"
                      className="pl-10"
                      disabled={submitting}
                      required
                    />
                  </div>
                </div>
                <Button
                  type="submit"
                  data-testid="forgot-submit"
                  disabled={submitting}
                  className="w-full bg-red-600 hover:bg-red-700 text-white py-3 font-semibold"
                >
                  {submitting ? 'Enviando...' : 'Enviar enlace de recuperación'}
                </Button>
              </form>
            )}

            <Link
              to="/admin/login"
              data-testid="forgot-back-login"
              className="mt-6 inline-flex items-center gap-2 text-sm text-slate-600 hover:text-red-600 transition-colors"
            >
              <ArrowLeft size={14} /> Volver al inicio de sesión
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
